import { render, staticRenderFns } from "./DhmeProjectIntakeRisks.vue?vue&type=template&id=ad43a750"
import script from "./DhmeProjectIntakeRisks.vue?vue&type=script&lang=js"
export * from "./DhmeProjectIntakeRisks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports